import { render, staticRenderFns } from "./BeforeInvoice.vue?vue&type=template&id=0dfb53f1"
import script from "./BeforeInvoice.vue?vue&type=script&lang=js"
export * from "./BeforeInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports